<div
  data-testid="html-description-container"
  class="html-description-container"
>
  <p-editor
    data-testid="html-description-editor"
    [ngModel]="getCurrentContent()"
    [placeholder]="computedConfig().placeholder | translate"
    [style]="{
      height: computedConfig().height,
      minHeight: computedConfig().minHeight,
      maxHeight: computedConfig().maxHeight
    }"
    [readonly]="isReadonly()"
    [disabled]="isDisabled()"
    [required]="computedConfig().required"
    [modules]="editorModules"
    (onTextChange)="onContentChange($event)"
    (onSelectionChange)="onSelectionChange($event)"
  ></p-editor>

  <!-- Character count footer -->
  <div data-testid="html-description-footer" class="editor-footer">
    <div
      data-testid="html-description-count"
      class="count-display"
      [class.over-limit]="isOverLimit()"
    >
      {{ getCharacterCount() }} / {{ computedConfig().maxLength }}
      {{ "material.form.rich_text_editor.characters" | translate }}
      @if (isOverLimit()) {
      <span data-testid="html-description-over-limit" class="over-limit-text"
        >({{ "common.validation.maxlength_exceeded" | translate }})</span
      >
      }
    </div>
  </div>
</div>
